import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import {
  getAvailableFacetNameAttributesList,
  getAlgoliaCategoryFacetsNames,
  getSelectedFacetsCategory,
  updateCategoryFacetValues,
} from 'selectors/algolia2/facets'
import { getHrefFunction } from './helper'

const mapStateToProps = createStructuredSelector({
  getHref: getHrefFunction,
  categoryFacets: getAlgoliaCategoryFacetsNames,
  getInitialCategoryFacets: (state) => {
    return getAvailableFacetNameAttributesList('category')(state)
  },
  selectedCategory: getSelectedFacetsCategory,
  updateCategoryFacetValues: (state) => {
    return (facetName: string, facetValue: string) => {
      return updateCategoryFacetValues(facetName, facetValue)(state)
    }
  },
})

export type CategoryFacetConnectorProps = {
  getHref: (filterParam: Record<string, any>) => string
  categoryFacets: ReadonlyArray<string>
  getInitialCategoryFacets: ReadonlyArray<string>
  selectedCategory: string
  updateCategoryFacetValues: (facetName: string, facetValue: string) => ReadonlyArray<string>
}

export default connect(mapStateToProps)
